import React, { createContext, useContext, useState } from 'react';

interface CookieBannerContextType {
  isOpen: boolean;
  openBanner: () => void;
  closeBanner: () => void;
}

const CookieBannerContext = createContext<CookieBannerContextType | undefined>(
  undefined
);

export const useCookieBanner = () => {
  const context = useContext(CookieBannerContext);
  if (!context) {
    throw new Error(
      `'useCookieBanner must be used within a CookieBannerProvider'`
    );
  }
  return context;
};

export const CookieBannerProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openBanner = () => {
    setIsOpen(true);
  };

  const closeBanner = () => {
    setIsOpen(false);
  };

  return (
    <CookieBannerContext.Provider value={{ isOpen, openBanner, closeBanner }}>
      {children}
    </CookieBannerContext.Provider>
  );
};
